module.exports = __webpack_public_path__ + "img/guang.e5285257.png";